import { render, staticRenderFns } from "./MaterialDonationSettings.vue?vue&type=template&id=2b261a06&"
import script from "./MaterialDonationSettings.vue?vue&type=script&lang=js&"
export * from "./MaterialDonationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports